import { Grid2, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import theme, { TMaterialStyles } from '../../theme';

interface ICommonLabel {
  attempts?: number;
}

export const AttemptsLabel: React.FC<ICommonLabel> = ({ attempts }) => {
  const { t } = useTranslation();

  if (attempts === undefined || attempts === null) {
    return;
  }

  return (
    <Grid2 sx={materialStyles.container}>
      <Typography>
        {attempts} {t('game.attempts_left')}
      </Typography>
    </Grid2>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    position: 'absolute',
    bottom: '-20px',
    background: theme.palette.grey[50],
    boxShadow: `0px 3px 0px ${theme.palette.grey[100]}`,
    width: '165px',
    height: '41px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '11px',
    fontSize: '16px',
    fontWeight: 700,
    letterSpacing: '0.1px',
    textShadow: `0px 2px 0px ${theme.palette.grey[200]}`,
  },
};
